import { Alert as AlertAntd } from 'antd';
import styled from 'styled-components';

export const Alert = styled(AlertAntd)`
  height: 50px !important;

  .ant-alert-warning {
    background-color: #fffbe6 !important;
    border: 1px solid #ffe58f;
    box-sizing: border-box;
    border-radius: 2px;
    position: absolute !important;
  }

  .ant-alert-message {
    font-family: Roboto !important;
    font-style: normal;
    font-weight: bold !important;
    font-size: 14px;
    line-height: 22px;
    color: #6a6a6a !important;
  }
`;
